import React from 'react'
import { connect } from 'react-redux'
import { withNamespaces } from "react-i18next"
import { MapPin, Grid, Mail, CreditCard, Check } from "lucide-react";

class StepBar extends React.Component {

  getGradientStyle() {
    const { qrData } = this.props;
    if (qrData?.headerConfig?.primaryColor && qrData?.headerConfig?.secondaryColor) {
      return `linear-gradient(90deg, ${qrData.headerConfig.primaryColor} 0%, ${qrData.headerConfig.secondaryColor} 100%)`;
    }
    return 'linear-gradient(45deg, #01315f, #067ddb)';
  }

  getPrimaryTextColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.textPrimary || '#01315f';
  }

  renderStep(stepNumber, currentStep, label, Icon) {
    const isActive = currentStep === stepNumber;
    const isOld = currentStep > stepNumber;
    const gradient = this.getGradientStyle();
    const textColor = this.getPrimaryTextColor();

    // For active step, use custom animation; for old steps, static background
    const stepStyle = isActive ? {
      animation: 'customColorLoop 1s ease-in-out infinite alternate'
    } : (isOld ? { background: gradient } : {});
    const labelStyle = (isActive || isOld) ? { color: textColor } : {};

    return (
      <div className="rental-stepparent">
        <div 
          className={
            isOld ? "rental-stepOld" : (isActive ? "rental-stepActive" : "rental-step")
          }
          style={stepStyle}
        >
          {isOld ? <Check size={18}/> : <Icon size={18}/>}
        </div>
        <div 
          className={
            isOld ? "rental-steplabelOld" : (isActive ? "rental-steplabelActive" : "rental-steplabel")
          }
          style={labelStyle}
        >
          {label}
        </div>
      </div>
    );
  }

  render() {
    const step = this.props.step;
    const { t } = this.props;
    const gradient = this.getGradientStyle();

    return (
      <>
        {/* Dynamic keyframes for active step animation */}
        <style>
          {`
            @keyframes customColorLoop {
              from {
                background: ${gradient};
                background-color: none;
                color: #fff;
              }
              to {
                background: none;
                background-color: #f0f2f4;
                color: grey;
              }
            }
          `}
        </style>
        <div className="rental-stepbar">

        {this.renderStep(1, step, t('Zona'), MapPin)}
        <div className={`${step > 1 ? "rental-steplineOld" : "rental-stepline"}`} style={step > 1 ? { background: gradient } : {}}></div>

        {this.renderStep(2, step, t('Taquilla'), Grid)}
        <div className={`${step > 2 ? "rental-steplineOld" : "rental-stepline"}`} style={step > 2 ? { background: gradient } : {}}></div>

        {this.renderStep(3, step, t('Email'), Mail)}
        <div className={`${step > 3 ? "rental-steplineOld" : "rental-stepline"}`} style={step > 3 ? { background: gradient } : {}}></div>

        {this.renderStep(4, step, t('Pago'), CreditCard)}

        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
});

export default connect(mapStateToProps)(withNamespaces()(StepBar))
